import { UserInfo } from '@antegma/accallio-cloud-hootsuite-adobe-workfront-api-javacript-sdk'
import { AnyAction } from 'redux'
import actions from './actions'

export type TCommonState = {
  loading: boolean
  currentUser: UserInfo
}
const initialState = {
  loading: false,
  currentUser: {},
}
export default function commonReducer(state: TCommonState = initialState, action: AnyAction): TCommonState {
  switch (action.type) {
    case actions.SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.GET_STATE:
      return state
    default:
      return state
  }
}
